import React, { Component } from 'react'
import Footer from '../footer'
import MetaTags from 'react-meta-tags'
import Navbusiness from '../navbusiness'
import jump from 'jump.js'
import '../../business-solution.css'
import TextLeftComponent from './textLeftComponent'
import TextRightComponent from './textRightComponent'

class BusinessSolution extends Component {

    componentWillMount() {
        window.scrollTo(0, 0)
    }

    componentDidUpdate() {
        const hash = window.location.hash
        if (document.querySelector(hash)) {
            setTimeout(() => {
                jump(document.querySelector(hash), {
                    offset: -100
                })
            }, 100)
        }
    }

    render() {
        // console.log('metatag')
        return (
            <div className='business-page'>
                {/* รอแก้ไข */}
                <Navbusiness history={this.props.history} />
                {/* รอแก้ไข */}
                <div>
                    <MetaTags>
                        <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                        <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                        <meta property="og:url" content={window.location.href} />
                        <meta property="og:image" content={'imgsrc'} />
                        <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                        <meta property="og:type" content='website' />
                        <meta property="fb:pages" content="129193147647837" />
                    </MetaTags>

                    {/* row0 */}

                    {/* mobile */}
                    {/* <div className='hidden-md hidden-lg row2-mobile'
                        style={{ backgroundImage: "url(../../static/images/business-customer/bg-dl-mobile.jpg)" }}>
                        <div className='content'>
                            <div className='text'>
                                <h1 className='no-margin bold'>สะดวกสบายกับ<br className='hidden-sm' />แอปพลิเคชั่น<br />ส่งสด ใหม่!<br className='hidden-sm' /> ได้แล้ววันนี้!</h1>
                                <h2>ดาวน์โหลดแอปพลิเคชั่น ส่งสด ใหม่ ใช้งานง่าย สะดวก สบายกว่าเดิม <br /> ครบทุกหมวดหมู่ที่คุณต้องใช้ คลิกดาวน์โหลดด้านล่างได้เลย !!!</h2>
                            </div>
                            <div className='category-group'>
                                <h2></h2>
                                <div className='categories'>
                                    <div className='category'>
                                        <a href="https://apps.apple.com/us/app/songsod-groceries-delivery/id1476135553?mt=8">
                                            <img src="../../static/images/business-customer/logo-ios.png" />
                                        </a>
                                        <h4>iOS</h4>
                                    </div>
                                    <div className='category'>
                                        <a href="https://play.google.com/store/apps/details?id=com.plaping.songsod2019">
                                            <img src="../../static/images/business-customer/logo-android.png" />
                                        </a>
                                        <h4>Android</h4>
                                    </div>
                                </div>
                            </div>
                            <div className='text'>
                                <h2>
                                    ครอบคลุมทุกหมวดหมู่สินค้า อาทิเช่น เนื้อสัตว์ ไข่ อาหารทะเล ผักสด ผลไม้สดและอื่น ๆ<br /><br />
                                    เช็คและติดตามสถานะคำสั่งซื้อสินค้าได้แบบเรียลไทม์<br /><br />
                                    จัดส่งสินค้าตามช่วงเวลาจัดส่ง ตามที่คุณต้องการได้ล่วงหน้าสูงสุด 1 วัน<br /><br />
                                    สะดวกสบายด้วยการชำระค่าสินค้าผ่านบัตรเครดิต<br /><br /><br />
                                </h2>
                            </div>
                        </div>
                    </div> */}

                    {/* --- row1 --- */}
                    {/* pc */}
                    <div id='service' className='hidden-xs hidden-sm row1-pc'>
                        <img src="../../static/images/business-customer/background_1.jpg" />
                        <div className='overlay'></div>
                        <div className='text'>
                            <div className='border' style={{ border: 'solid 2px white', borderRadius: 12, padding: '10px 15px' }}>
                                <h1 className='no-margin'>
                                    คัดเลือกสินค้า
                                <span className='shipping-price'>ราคาส่ง</span>
                                </h1>
                                <h2>จากทุกร้านในตลาดยิ่งเจริญ</h2>
                            </div>
                            <h2>ส่งถึงมือคุณ</h2>
                            <ul className='text-shadow'>
                                <li>เหมาะสำหรับธุรกิจ ร้านอาหาร ทุกประเภท</li>
                                <li>หลากหลาย ครบจบ ในที่เดียว</li>
                                <li>คัดสรรโดยผู้เชี่ยวชาญ รับประกันคุณภาพความสด**</li>
                                <li>ไม่มีขั้นต่ำในการสั่งซื้อ ไม่จำเป็นต้องสั่งล่วงหน้า</li>
                                <li>บริการรถจัดส่ง (ฟรี***) เลือกเวลาได้</li>
                                <li>รับชำระด้วยบัตรเครดิต</li>
                                <li>ให้บริการทุกวัน ไม่เว้นวันหยุด</li>
                                <li>ออกใบกำกับภาษีรูปแบบบริษัท</li>
                            </ul>
                        </div>
                    </div>

                    {/* mobile */}
                    <div className='hidden-md hidden-lg row1-mobile'
                        style={{ backgroundImage: "url(../../static/images/business-customer/background_1.jpg)" }}>
                        <div className='overlay'></div>
                        <div className='text'>
                            <div className='border' style={{ border: 'solid 2px white', borderRadius: 12, padding: '10px 15px' }}>
                                <h1 className='no-margin'>
                                    คัดเลือกสินค้า
                                <span className='shipping-price'>ราคาส่ง</span>
                                </h1>
                                <h2>จากทุกร้านในตลาดยิ่งเจริญ</h2>
                            </div>
                            <h2>ส่งถึงมือคุณ</h2>
                            <ul className='text-shadow'>
                                <li>เหมาะสำหรับธุรกิจ ร้านอาหาร ทุกประเภท</li>
                                <li>หลากหลาย ครบจบ ในที่เดียว</li>
                                <li>คัดสรรโดยผู้เชี่ยวชาญ รับประกันคุณภาพความสด**</li>
                                <li>ไม่มีขั้นต่ำในการสั่งซื้อ ไม่จำเป็นต้องสั่งล่วงหน้า</li>
                                <li>บริการรถจัดส่ง (ฟรี***) เลือกเวลาได้</li>
                                <li>รับชำระด้วยบัตรเครดิต</li>
                                <li>ให้บริการทุกวัน ไม่เว้นวันหยุด</li>
                                <li>ออกใบกำกับภาษีรูปแบบบริษัท</li>
                            </ul>
                        </div>
                    </div>

                    {/* row2 */}
                    {/* pc */}
                    <div className='hidden-xs hidden-sm row2-pc'>
                        <img src="../../static/images/business-customer/background_white.jpg" />
                        <div className='content'>
                            <div className='text'>
                                <h1 className='no-margin bold'>คลังแห่งวัตถุดิบ ราคา ปลีก-ส่ง <br />หลากหลาย ครบ จบ ในที่เดียว</h1>
                                <h2>เราเลือกสรรสินค้าที่มีคุณภาพ จากทุกร้านในตลาดยิ่งเจริญ <br /> ครบทุกหมวดหมู่ที่ร้านของคุณจำเป็นต้องใช้ ทั้งหาง่ายและหายาก</h2>
                            </div>
                            <div className='category-group'>
                                <h2>หมวดหมู่สินค้า</h2>
                                <div className='categories'>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/เนื้อสัตว์.png" />
                                        <h4>เนื้อสัตว์</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/อาหารทะเล.png" />
                                        <h4>อาหารทะเล</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ปลา.png" />
                                        <h4>ปลาน้ำจืด</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ผัก.png" />
                                        <h4>ผักสด</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ผลไม้.png" />
                                        <h4>ผลไม้</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/เครื่องแกง.png" />
                                        <h4>เครื่องแกง</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/วัตถุดิบ.png" />
                                        <h4>วัตถุแปรรูป</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ไข่.png" />
                                        <h4>ไข่</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ของแห้ง.png" />
                                        <h4>ของแห้ง</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/แป้ง.png" />
                                        <h4>แป้งและเครื่องเส้น</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ข้าว.png" />
                                        <h4>ข้าวและธัญพืช</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/เครื่องปรุง.png" />
                                        <h4>เครื่องปรุงซอสและน้ำมัน</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/อาหารปรุงสำเร็จ.png" />
                                        <h4>อาหารปรุงสำเร็จ</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ดอกไม้.png" />
                                        <h4>ดอกไม้สดและเครื่องบูชา</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/อื่น.png" />
                                        <h4>อื่นๆ</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* mobile */}
                    <div className='hidden-md hidden-lg row2-mobile'
                        style={{ backgroundImage: "url(../../static/images/business-customer/background_white.jpg)" }}>
                        <div className='content'>
                            <div className='text'>
                                <h1 className='no-margin bold'>คลังแห่งวัตถุดิบ <br className='hidden-sm' />ราคา ปลีก-ส่ง<br />หลากหลาย ครบ จบ<br className='hidden-sm' /> ในที่เดียว</h1>
                                <h2>เราเลือกสรรสินค้าที่มีคุณภาพ จากทุกร้านในตลาดยิ่งเจริญ <br /> ครบทุกหมวดหมู่ที่ร้านของคุณจำเป็นต้องใช้ ทั้งหาง่ายและหายาก</h2>
                            </div>
                            <div className='category-group'>
                                <h2>หมวดหมู่สินค้า</h2>
                                <div className='categories'>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/เนื้อสัตว์.png" />
                                        <h4>เนื้อสัตว์</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/อาหารทะเล.png" />
                                        <h4>อาหารทะเล</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ปลา.png" />
                                        <h4>ปลาน้ำจืด</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ผัก.png" />
                                        <h4>ผักสด</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ผลไม้.png" />
                                        <h4>ผลไม้</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/เครื่องแกง.png" />
                                        <h4>เครื่องแกง</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/วัตถุดิบ.png" />
                                        <h4>วัตถุแปรรูป</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ไข่.png" />
                                        <h4>ไข่</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ของแห้ง.png" />
                                        <h4>ของแห้ง</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/แป้ง.png" />
                                        <h4>แป้งและเครื่องเส้น</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ข้าว.png" />
                                        <h4>ข้าวและธัญพืช</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/เครื่องปรุง.png" />
                                        <h4>เครื่องปรุงซอสและน้ำมัน</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/อาหารปรุงสำเร็จ.png" />
                                        <h4>อาหารปรุงสำเร็จ</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/ดอกไม้.png" />
                                        <h4>ดอกไม้สดและเครื่องบูชา</h4>
                                    </div>
                                    <div className='category'>
                                        <img src="../../static/images/business-customer/อื่น.png" />
                                        <h4>อื่นๆ</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* --- row3 --- */}
                    <TextRightComponent
                        imgPCURL={'../../static/images/business-customer/background3_pc.jpg'}
                        imgMobileURL={'url(../../static/images/business-customer/background3_mobile.jpg)'}
                        row={'row3'}>
                        <h2>จัดปริมาณสินค้าแต่ละชนิดตามที่คุณต้องการ</h2>
                        <h1>ทั้ง ปลีก-ส่ง ไม่มีขั้นต่ำ*</h1>

                        <div className='border'>
                            <h4 style={{ marginTop: 0, marginBottom: 20 }}>สินค้าสามารถตัดแต่งตามรูปแบบที่คุณต้องการใช้งาน*</h4>
                            <h4>หากคุณมีร้านค้าประจำสามารถแจ้งกับเราได้</h4>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <h4 className='black-border'>*ขึ้นอยู่กับชนิดของสินค้า สามารถสอบถามข้อมูลเพิ่มเติมกับเราได้</h4>
                        </div>
                    </TextRightComponent>

                    {/* --- row4 --- */}
                    <div id='guarantee'>
                        <TextLeftComponent
                            imgPCURL={'../../static/images/business-customer/background4_pc.jpg'}
                            imgMobileURL={'url(../../static/images/business-customer/background4_mobile.jpg)'}
                            row={'row4'}>
                            <h1 className='bold'>มั่นใจในคุณภาพ</h1>
                            <h2>คัดเลือกด้วย <span className='expert bold'>ผู้เชี่ยวชาญ</span></h2>
                            <div className='text-description'>
                                <h4>
                                    {'หมดห่วงเรื่องสินค้ายัดไส้ เพราะเราคัดเลือกสินค้า โดยทีมงานผู้คัดสรรส่วนตัว\nมีประสบการณ์และความเชี่ยวชาญในสินค้าตลาดสดทุกชนิด'}
                                </h4>
                                <h4>{'จึงพร้อมตอบสนองความต้องการทุกด้านของท่านดุจญาติมิตรด้วยความ\nเป็นกลางไม่มียัดไส้'}</h4>
                                <h4>ทีมงานของเราจะดูแลสินค้าพร้อมแพ็คสินค้าอย่างเหมาะสมตามชนิดสินค้า</h4>
                                <h4 className='bold'>มั่นใจในความสดใหม่ จนถึงมือคุณ</h4>
                            </div>
                            <div>
                                <img style={{ width: '20%', display: 'inline-block' }} src='../../static/images/business-customer/bag.png' />
                                <div style={{ width: '80%', display: 'inline-block', verticalAlign: 'middle', paddingLeft: 20 }}>
                                    <h2 style={{ marginTop: 10 }}>รับประกันคุณภาพ ไม่สด เราไม่ส่ง</h2>
                                    <h4 style={{ color: '#233268' }}>เรายินดีรับเปลี่ยนคืนสินค้าที่เสียหายหรือ</h4>
                                    <h4 style={{ color: '#233268' }}>ไม่ได้คุณภาพ หมดปัญหา ของไม่สด**</h4>
                                </div>
                            </div>
                        </TextLeftComponent>
                    </div>

                    {/* --- row5 --- */}
                    <div id='transport'>
                        <img style={{ width: 'auto', zIndex: 10, position: 'absolute', right: 0 }}
                            className='box-delivery' src='../../static/images/business-customer/box-delivery.png' />
                        <TextRightComponent
                            imgPCURL={'../../static/images/business-customer/background5_pc.jpg'}
                            imgMobileURL={'url(../../static/images/business-customer/background5_mobile.jpg)'}
                            row={'row5'}>
                            <h2 className='bold'>ไม่จำเป็นต้องสั่งล่วงหน้า***</h2>
                            <h2 className='bold' style={{ marginTop: 10, marginBottom: 40 }}>ไม่มีขั้นต่ำในการสั่งซื้อสินค้า</h2>
                            <ul>
                                <li>เรายินดีจัดส่งในทุกปริมาณการสั่งซื้อไม่มีขั้นต่ำในการสั่ง</li>
                                <li>เรามีสินค้าราคาส่งให้บริการ สำหรับลูกค้าที่สั่งปริมาณมาก หรือสั่งประจำ</li>
                                <li>เราสามารถส่งด่วนได้ ภายใน 2-3 ชั่วโมงโดยไม่ต้องนัดเวลาล่วงหน้า***</li>
                            </ul>
                        </TextRightComponent>
                        <img style={{ width: 'auto', zIndex: 10, position: 'absolute', left: 0 }}
                            className='pic-pig' src='../../static/images/business-customer/pic_pig.png' />
                    </div>

                    {/* row6 */}
                    <TextRightComponent
                        imgPCURL={'../../static/images/business-customer/background_6.jpg'}
                        imgMobileURL={'url(../../static/images/business-customer/background_6.jpg)'}
                        row={'row6'}>
                        <h4 className='bold'>ที่สุดแห่งความสะดวก ยืดหยุ่นตามธุรกิจของคุณ</h4>
                        <h2 className='bold'>จัดส่งสินค้า ในเวลาที่เลือกได้</h2>
                        <h4>เราเปิดให้บริการทุกวัน ไม่เว้นวันหยุดราชการ</h4>
                        <h3>รอบเวลาส่งตั้งแต่</h3>
                        <h1 className='bold'>4.00- 18.00 น.</h1>
                        <h3>หรือส่งรอบพิเศษได้</h3>
                    </TextRightComponent>

                    {/* row7 */}
                    <div id='payment'>
                        <TextLeftComponent
                            imgPCURL={'../../static/images/business-customer/background7_pc.jpg'}
                            imgMobileURL={'url(../../static/images/business-customer/background7_mobile.jpg)'}
                            row={'row7'}>
                            <h2 className='bold'><span className='big'>ใหม่!</span> สะดวกยิ่งกว่าเดิม<br />ชำระเงินผ่านบัตรเครดิต</h2>
                            <h4>... คุณสามารถชำระเงินได้<br />ด้วยช่องทางการโอนเงิน...</h4>
                            <h3 className='bold'>พร้อมเพย์<span className='or'> หรือ </span>บัตรเครดิต</h3>
                            <img style={{ width: '60%' }} src="../../static/images/business-customer/payment.png" />
                        </TextLeftComponent>
                    </div>

                    {/* --- row8 --- */}
                    <div className='img-wrapper-row8' style={{ backgroundColor: '#233268 !important', height: 600 }}>
                        <div className='business-sol-row8-position' style={{ top: '50%' }}>
                            <h2 className='business-sol-row8-head' id='contractme'>ใส่ใจคุณดุจญาติมิตร<br /><span className='business-sol-row8-span'>เพราะเราคือเพื่อนคู่คิด ธุรกิจอาหารทุกประเภท</span></h2>
                            <h2 style={{ margin: '30px 0' }} className='business-sol-row8-detail'>สามารถติดต่อกับทีมงานได้โดยตรงทั้งใน และนอกเวลา</h2>
                            <div className='row'>
                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6'>
                                    <img onClick={() => {
                                        window.open('https://line.me/R/ti/p/%40songsod')
                                    }} className='pointer' style={{ marginBottom: 20, cursor: 'pointer' }} src="../../static/images/business-customer/line.png" />
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6'>
                                    <img onClick={() => {
                                        window.open('https://www.facebook.com/songsoddelivery')
                                    }} style={{ cursor: 'pointer' }} src="../../static/images/business-customer/facebook.png" />
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* --- Row Line FB Google --- */}
                    <div>
                        <iframe className='business-sol-gmap' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d992.4714461045124!2d100.60815722232128!3d13.897071628382642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e28299ff1149af%3A0x2929331072f42f58!2sYing+Charoen+Market!5e0!3m2!1sen!2sth!4v1501014647075"></iframe>
                    </div>

                </div>

                <Footer />
            </div >

        )
    }
}

export default BusinessSolution


// WEBPACK FOOTER //
// ./src/components/business-solution/page_business_solution.js